<div class="container">
  <div class="user-list mt-3 mb-3 table-responsive" *ngIf="discounts.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th class="text-center" scope="col">#</th>
        <th class="text-center" scope="col">Value</th>
        <th class="text-center" scope="col">Discount Type</th>
        <th class="text-center" scope="col">Booking Type</th>
        <th></th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let discount of discounts">
        <td class="text-center">{{ discount.id }}</td>
        <td class="text-center">{{ discount.value }}</td>
        <td class="text-center">{{ discount.type }}</td>
        <td class="text-center">{{ discount.bookingOption }}</td>
        <td class="text-center">
          <button type="button" class="btn btn-light edit-button" (click)="openEditModal(discount)">
            <i class="fas fa-pencil"></i>
          </button>
        </td>
        <td>
          <button type="button" class="btn btn-danger delete-button" (click)="openDeleteConfirmModal(discount)">
            <i class="fas fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="user-list mt-3 mb-3" *ngIf="discounts.length == 0">
    <p>You have no discount yet</p>
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>
  <div class="text-center">
    <button type="button" class="btn btn-default add-button" (click)="openEditModal(null)">
      <i class="fas fa-plus"></i> Add new
    </button>
  </div>
</div>
